import { careerFilterComponent, emailTarget } from './components/index';

// import external dependencies
import 'jquery';

import './util/focusTab';
import './util/smoothScroll';

import {
	accordionTriggerComponentTarget,
	anchorSideboxComponent,
	faqComponentTarget,
	featuredModuleTilesComponent,
	memberListingTilesComponent,
	modalContainerTarget,
	modalRegionComponent,
	modalVideoTarget,
	partnerLogoCarousel,
	resourcesCarousel,
	testimonialCarousel,
	modalMemberContent,
	articleFilterComponent,
	navigationDropdownComponent,
	resourcesFilterComponent,
	navDesktopComponentTarget,
	scrollingTextTilesCarousel,
	searchKeywordTarget,
	singleFormContent,
	navMobileComponentTarget,
	backPageTarget
} from './components';

import { initSocialShare } from './components/socialShare';
import { initHamburger } from './components/hamburger';
import { registerAppHeight } from './components/appHeight';

// Functions to run before Document loads


if ($(singleFormContent).length) {
	import('./components/singleForm').then((module) => {
		module.initSingleForm();
	});
}

let resizeTimeout;

// Load Events
jQuery(document).ready(() => {
	// Always used
	initLocalStorage();
	initHamburger();
	initSocialShare();
	registerAppHeight();

	if ($(accordionTriggerComponentTarget).length) {
		import('./components/accordion').then((module) => {
			module.initAccordion();
		});
	}

	if ($(searchKeywordTarget).length) {
		import('./components/searchKeyword').then((module) => {
			module.initSearch();
		});
	}

	if ($(anchorSideboxComponent).length) {
		import('./components/anchorSidebox').then((module) => {
			module.initAnchorSidebox();
		});
	}

	if ($(faqComponentTarget).length) {
		import('./components/faq').then((module) => {
			module.initFaq();
		});
	}

	if ($(featuredModuleTilesComponent).length) {
		import('./components/featuredModuleTiles').then((module) => {
			module.initFeaturedModuleTiles();
		});
	}
	
	if ($(memberListingTilesComponent).length) {
		import('./components/memberListingTiles').then((module) => {
			module.initMemberListingTiles();
		});
	}

	if ($(modalContainerTarget).length) {
		import('./components/modal').then((module) => {
			module.initModal();
		});
	}

	if ($(modalRegionComponent).length) {
		import('./components/regionModal').then((module) => {
			module.initRegionModal();
		});
	}

	if ($(modalMemberContent).length) {
		import('./components/modalMember').then((module) => {
			module.initModalMember();
		});
	}

	if ($(modalVideoTarget).length) {
		import('./components/modalVideo').then((module) => {
			module.initModalVideo();
		});
	}

	if ($(partnerLogoCarousel).length) {
		import('./components/partnerLogoCarousel').then((module) => {
			module.initPartnerLogoCarousel();
			jQuery(window).on('resize', function() {
				if(resizeTimeout) {
					clearTimeout(resizeTimeout);
				}
				resizeTimeout = setTimeout(function(){ 
					module.reinitPartnerLogoCarousel();
				}, 500)
			})
		});
	}

	if ($(resourcesCarousel).length) {
		import('./components/resourcesCarousel').then((module) => {
			module.initResourcesCarousel();
			jQuery(window).on('resize', function() {
				if(resizeTimeout) {
					clearTimeout(resizeTimeout);
				}
				resizeTimeout = setTimeout(function(){ 
					module.reinitResourcesCarousel();
				}, 500)
			})
		});
	}

	if ($(scrollingTextTilesCarousel).length) {
		import('./components/scrollingTextTilesCarousel').then((module) => {
			module.initScrollingTextTilesCarousel();
		});
	}

	if ($(testimonialCarousel).length) {
		import('./components/testimonialCarousel').then((module) => {
			module.initTestimonialCarousel();
		});
	}

	if ($('.wFormContainer').length) {
		import('./components/formAssembly').then(module => {
			module.initFormAssembly();
		})
	}

	if ($(articleFilterComponent).length) {
		import('./components/articleFilter').then(module => {
			module.initArticleFilter();
		})
	}

	if ($(careerFilterComponent).length) {
		import('./components/careerFilter').then(module => {
			module.initCareerFilter();
		})
	}

	if ($(navigationDropdownComponent).length) {
		import('./components/navigationDropdown').then((module) => {
			module.initNavigationDropdown();
		});
	}

	if ($(resourcesFilterComponent).length) {
		import('./components/resourcesFilter').then(module => {
			module.initResourcesFilter();
		});
	}

	if ($(navDesktopComponentTarget).length) {
		import('./components/navigationDesktop').then((module) => {
			module.initNavigationDesktop();
		});
	}

	if ($(navMobileComponentTarget).length) {
		import('./components/navigationMobile').then((module) => {
			module.initNavigationMobile();
		});
	}

	if ($(backPageTarget).length) {
		import('./components/backPage').then((module) => {
			module.initBackPage();
		});
	}

	if ($(emailTarget).length) {
		import('./components/encryptEmail').then((module) => {
			module.initEncryptEmail();
		})
	}
});

function initLocalStorage() {
	if (!('localStorage' in window) || typeof localStorage !== 'object') {
		return;
	}

	const storedRegion = localStorage.getItem('region');
	const cookieMatch = document.cookie.match(/(?:^|; )region=([^;]*)/);
	const cookieRegion = cookieMatch ? decodeURIComponent(cookieMatch[1]) : null;
	const $regionLabels = $('[data-region-trigger] .region-code');

	// Complete selection: keep header in sync. Incomplete/desynced: prompt label
	// (modal.ts clears partial state and opens the selector).
	if (storedRegion && cookieRegion) {
		$regionLabels.html(storedRegion.toUpperCase());
	} else {
		$regionLabels.html('Select State');
	}
}


// WEBPACK FOOTER //
// ./scripts/main.ts